"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.config.display.default.prompts.button': 'Not sure what to ask? Try our suggestions!',
    'chat.config.button.label.text': 'Send prompt',
    'chat.config.cancel.button.label.text': 'Cancel Generation',
    'chat.config.voice.button.label.text': 'voice input',
    'chat.config.voice.rec.button.label.text': 'Listening to voice input',
    'chat.config.input.newline.helper': ' for new line',
    'chat.config.autocomplete.styles.helper': ' for styles',
    'chat.config.autocomplete.projects.helper': ' for projects',
    'chat.config.autocomplete.knowledge.helper': ' for knowledge',
    'chat.config.live_chat.button.label.text': 'Live chat',
    'chat.config.input.placeholder': 'Type your question, e.g., "How can I help you?"',
    'chat.config.user.is.bot': 'Support Assistant',
    'chat.config.reset.button.label.text': 'X',
    'chat.config.reset.button.title.text': 'Reset current question',
    'chat.config.reset.chat.button.title': 'Reset chat',
    'chat.config.copy.response.button.label.text': 'Copy Response',
    'chat.config.copied.successfully.message': 'Response copied!',
    'chat.config.follow.up.questions.label.text': 'You can also ask...',
    'chat.config.show.thought.process.button.label.text': 'Show thought process',
    'chat.config.hide.thought.process.button.label.text': 'Hide thought process',
    'chat.config.loading.indicator.text': 'Please wait. We are searching and generating an answer...',
    'chat.config.loading.text': 'Loading...',
    'chat.config.api.error.message': 'Sorry, we are having some problems. Please try again later.',
    'chat.config.invalid.request.error': 'Unable to generate answer for this query. Please modify your question and try again.',
    'chat.config.thought.process.label': 'Thought Process',
    'chat.config.support.context.label': 'Support Context',
    'chat.config.reasoning.label': 'Reasoning',
    'chat.config.citations.label': 'Learn More:',
    'chat.config.citations.tab.label': 'Citations',
    'chat.config.branding.logo.alt': 'Brand Logo',
    'chat.config.branding.headline': 'Welcome to the Support Assistant of our Brand',
    'chat.config.show.chat.history.label': 'Show Chat History',
    'chat.config.hide.chat.history.label': 'Hide Chat History',
    'chat.config.chat.history.footer.text': 'Showing past {MAX_CHAT_HISTORY} conversations',
    'chat.config.web.search.checkbox.label': 'Use web search',
    'chat.config.deep.search.checkbox.label': 'Use deep search',
    'chat.config.adv.prompt.checkbox.label': 'Advanced prompting',
    'chat.config.autocomplete.style.selected': 'Style "{name}" has been added',
    'chat.config.autocomplete.project.selected': 'Project "{name}" has been added',
    'chat.config.autocomplete.knowledge.selected': 'Knowledge "{name}" has been added',
    'chat.config.add.kdb.button.label.text': 'Add to knowledge base',
};
